export default __webpack_public_path__ + "static/media/BorderLine.6e90711e.svg";